var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.canDetail || _vm.canEdit || _vm.canDelete || _vm.hasDefaultSlot
    ? _c(_vm.tag, { tag: "component", staticClass: "actions" }, [
        _c(
          "ul",
          {
            staticClass:
              "list-group list-group-horizontal list-unstyled justify-content-end",
            class: _vm.listClass,
          },
          [
            _vm._t("default", null, {
              confirm: _vm.confirm,
              formatMsg: _vm.formatMsg,
            }),
            _vm._v(" "),
            _vm.routeEdit && (_vm.canDetail || _vm.canEdit)
              ? _c(
                  "li",
                  { staticClass: "list-group-item" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: _vm.routeEdit,
                            params: { id: _vm.row[_vm.keyProperty] },
                            query: _vm.routeEditQuery,
                          },
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "fas action",
                          class: [
                            _vm.canEdit ? "fa-pencil-alt edit" : "fa-eye view",
                          ],
                          attrs: { title: _vm.translatedEditTitle },
                        }),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canDelete
              ? _c("li", { staticClass: "list-group-item" }, [
                  _c("i", {
                    staticClass: "far fa-trash-alt action delete",
                    attrs: { title: _vm.translatedDeleteTitle },
                    on: {
                      click: function ($event) {
                        _vm.confirm(
                          _vm.deleteItem,
                          _vm.row[_vm.keyProperty],
                          _vm.index,
                          _vm.formatMsg(_vm.deleteMsgTemplate)
                        )
                      },
                    },
                  }),
                ])
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }